import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { formatNumber, t } from 'state/intl/translations';
import { getUnitForNutrient } from 'utils/menu';

import { NutrientItem } from '../use-nutrient-items';

type Props = {
  nutrients: NutrientItem[];
};

export const NutrientList = ({ nutrients }: Props) => {
  return (
    <>
      {nutrients.map(({ label, value }) => (
        <Box key={label} style={styles.row} focusable>
          <Typography style={{ textTransform: 'capitalize' }}>{t(`us-${label}`)}</Typography>
          <Typography>
            {label === 'calories'
              ? `${formatNumber(Math.floor(value), {
                  maximumFractionDigits: 0,
                })} ${getUnitForNutrient(label)}`
              : `${formatNumber(value, { maximumFractionDigits: 1 })} ${getUnitForNutrient(label)}`}
          </Typography>
        </Box>
      ))}
    </>
  );
};

const styles = StyleSheet.create({
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 1,
  },
});
